import { Box, Card, Flex, Heading } from "@radix-ui/themes";
import { useEffect } from "react";
import useAppLogo from "../../assets/use-app-icon.png";
import { APPLE_APP_STORE_LINK, GOOGLE_PLAY_STORE_LINK } from "../app-links";
import { isWebAndroidPlatform, isWebIOSPlatform } from "../utils/environment";
import { AppStoreButtons } from "./app-store-buttons.component";

function getPlatformStoreLink(): string | null {
  if (isWebIOSPlatform()) return APPLE_APP_STORE_LINK;
  if (isWebAndroidPlatform()) return GOOGLE_PLAY_STORE_LINK;
  return null;
}

export const AppHandoffPage: React.FC = () => {
  const platformStoreLink = getPlatformStoreLink();

  useEffect(() => {
    if (!platformStoreLink) return;

    const redirectTimer = window.setTimeout(() => {
      window.location.replace(platformStoreLink);
    }, 150);

    return () => window.clearTimeout(redirectTimer);
  }, [platformStoreLink]);

  return (
    <Box asChild>
      <main
        style={{
          minHeight: "100dvh",
          display: "grid",
          placeItems: "center",
          padding:
            "max(24px, env(safe-area-inset-top)) 20px max(24px, env(safe-area-inset-bottom))",
          boxSizing: "border-box",
          background:
            "radial-gradient(circle at top, rgba(31, 41, 55, 0.08), transparent 45%), #f8f8f7",
        }}
      >
        <Card
          size="4"
          style={{
            width: "min(100%, 440px)",
            border: "1px solid rgba(31, 41, 55, 0.1)",
            boxShadow: "0 24px 70px rgba(31, 41, 55, 0.12)",
          }}
        >
          <Flex direction="column" gap="5" align="center">
            <img
              src={useAppLogo}
              alt="Use logo"
              style={{
                width: "64px",
                height: "64px",
                borderRadius: "14px",
                boxShadow: "0 10px 28px rgba(31, 41, 55, 0.2)",
              }}
            />
            <Flex direction="column" gap="2" align="center">
              <Heading as="h1" size="7" align="center">
                Use App öffnen
              </Heading>
            </Flex>

            <AppStoreButtons showDescription={false} />
          </Flex>
        </Card>
      </main>
    </Box>
  );
};
